import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import './SideMenu.scss'

import providersIcon from 'assets/images/nav/providersIcon.svg'
import passportsIcon from 'assets/images/nav/passportsIcon.svg'
import reservationIcon from 'assets/images/nav/reservation.svg'
import Clients from 'assets/images/sidemenu/Clients.svg'
import Configurations from 'assets/images/sidemenu/Configurations.svg'
import Dashboard from 'assets/images/sidemenu/Dashboard.svg'
import Flight from 'assets/images/sidemenu/Flight.svg'
import Transportation from 'assets/images/sidemenu/Transportation.svg'
import catering from 'assets/images/sidemenu/catering.svg'
import hotel from 'assets/images/sidemenu/hotelOr.svg'
import Marketplace from 'assets/images/Marketplace.svg'
import hotelGrey from 'assets/images/sidemenu/hotelGrey.svg'
import users from 'assets/images/sidemenu/users.svg'
import packagee from 'assets/images/sidemenu/Packages.svg'
import groups from 'assets/images/sidemenu/groupOr.svg'
import logo from 'assets/images/logo1.png'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store/reducers'
import { useState } from 'react'

export default function SideMenu(): JSX.Element {
  const { t } = useTranslation() // ti18n
  const userInfo = useSelector((state: RootState) => state.UserInfo.user)
  const [showHotelsDropList, setShowHotelsDropList] = useState(false)
  const permitions = useSelector((state: any) => state?.UserInfo?.user?.Permissions)

  return (
    <div className="SideMenu bg-white min-vh-100">
      <div className="menu relative">
        <div className="flex items-center w-full h-full p-3  mb-2">
          <img src={logo} alt="dashboard" className="w-[50%]  h-full object-contain" />
        </div>
        {permitions.find((ele: any) => ele.Module === 'Dashboard').IsActive && (
          <NavLink to="/admin/dashboard" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={Dashboard}
                alt="Dshboard"
                className="w-6 h-6 mr-2 ml-ar-2 mr-ar-0 object-contain mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Dashboard')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Hotel').IsActive && (
          <NavLink to="/admin/hotels" className=" hotelLink">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={hotel}
                alt="Hotels"
                className="w-6 h-6 mr-2 ml-ar-2 mr-ar-0 object-contain mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Hotels')}</p>
            </div>
          </NavLink>
        )}

        {permitions.find((ele: any) => ele.Module === 'Flight').IsActive && (
          <NavLink to="/admin/flight" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={Flight}
                alt="Flight"
                className="w-6 h-6 mr-2 ml-ar-2 mr-ar-0 object-contain mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Flight')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Trasportaiton').IsActive && (
          <NavLink to="/admin/Transportation" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={Transportation}
                alt="Transportation"
                className="w-6 h-6 object-contain mr-2 ml-ar-2 mr-ar-0 mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700">
                {' '}
                {t('Transportation')}
              </p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Catering').IsActive && (
          <NavLink to="/admin/catering" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={catering}
                alt="Catering"
                className="w-6 mr-2 ml-ar-2 mr-ar-0 h-6 object-contain mt-[1px] p-[1px]"
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Catering')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Package').IsActive && (
          <NavLink to="/admin/Packages" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={packagee}
                alt="Packages"
                className="w-6 h-6 mr-2 ml-ar-2 mr-ar-0 object-contain mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Packages')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Client').IsActive && (
          <NavLink to="/admin/Clients" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={Clients}
                alt="Clients"
                className="w-6 h-6 ml-ar-2 mr-ar-0 object-contain mr-2 mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Clients')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Group').IsActive && (
          <NavLink to="/admin/groups" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={groups}
                alt="Groups"
                className="w-6 h-6 ml-ar-2 mr-ar-0 object-contain mr-2 mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700"> {t('Groups')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'User').IsActive && (
          <NavLink to="/admin/users" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={users}
                alt="Users"
                className="w-6 h-6 mr-2  ml-ar-2 mr-ar-0 object-contain mt-[1px] p-[1px] "
              />
              <p className=" px-2  pt-1 m-0 text-sm  font-light text-gray-700"> {t('Users')}</p>
            </div>
          </NavLink>
        )}
        {permitions.find((ele: any) => ele.Module === 'Configuration').IsActive && (
          <NavLink to="/admin/Settings" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={Configurations}
                alt="Configurations"
                className="w-6 h-6 ml-ar-2 mr-ar-0 object-contain mr-2  mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700">
                {' '}
                {t('Configurations')}
              </p>
            </div>
          </NavLink>
        )}

        {permitions.find((ele: any) => ele.Module === 'MarketPlace').IsActive && (
          <NavLink to="/admin/MarketplaceSettings" className=" ">
            <div className="flex  align-items-center p-2 px-3 LinkPage">
              <img
                src={Marketplace}
                alt="Configurations"
                className="w-6 h-6 ml-ar-2 mr-ar-0 object-contain mr-2  mt-[1px] p-[1px] "
              />
              <p className=" px-2 pt-1  m-0 text-sm font-light text-gray-700">
                {' '}
                {t('MarketPlace')}
              </p>
            </div>
          </NavLink>
        )}
      </div>
    </div>
  )
}
